import { render, staticRenderFns } from "./EmailListing.vue?vue&type=template&id=3bb540a8"
import script from "./EmailListing.vue?vue&type=script&lang=js"
export * from "./EmailListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports